
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { Col, Row } from 'reactstrap';

import { useAcceptJs, HostedForm  } from 'react-acceptjs';
import '../assets/css/AuthorizeNetStyles.css'; // Import the external styles
import { SEND_SINGLE_AUTHORIZE_NET_A_TRANSACTION } from '../graphql/mutations/authorizeneta';

function AuthorizeNetA() {
 //start of custom stuff
  const [loading, setLoading] = useState(false);
  const [theCardToken, setCardToken] = useState();
  const [formError, setformError] = useState("enter your card information");
  // let cardToken;

  const [sendSingleAuthorizeNetATransaction] = useMutation(SEND_SINGLE_AUTHORIZE_NET_A_TRANSACTION);

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage({ type: 'FROM_IFRAME', payload: { data: data, action: action } }, process.env.REACT_APP_WOWCLOUD_PARENT + '/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111'); //Parent
  }

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent
  
      const { type, payload } = event.data;

      console.log("Payload", payload)
      if (type === 'FROM_PARENT') {
        if(payload.action === "SendBillingData"){
          const serverPayload = {
            token: theCardToken.token,
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(payload.data.zip),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(theCardToken.card.exp_month),
              expYear: parseInt(theCardToken.card.exp_year),
              lastFour: parseInt(theCardToken.card.last4),
              bin: theCardToken.card.bin
            }
          }

          SendSingleTransaction(serverPayload)
        }
        else if(payload.action == "Reset"){
          setLoading(false);
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [theCardToken]);

  const SendSingleTransaction = (serverPayload) => {
    sendSingleAuthorizeNetATransaction({ variables: {token: serverPayload.token, paymentdata: serverPayload.paymentdata}})
    .then((tres) => {
      if(tres.data.sendSingleAuthorizeNetATransaction.status){
        SendIFrameMessage(tres.data.sendSingleAuthorizeNetATransaction.data, "TransactionSuccess")
        // setLoading(false);
      }
      else{
        if(tres.data.sendSingleAuthorizeNetATransaction.error === "CardValidationRequired"){
          SendIFrameMessage(tres.data.sendSingleAuthorizeNetATransaction.error, "CardValidationRequired")
          setLoading(false);
        }
        else{
          SendIFrameMessage(tres.data.sendSingleAuthorizeNetATransaction.error, "TransactionError")
          setLoading(false);
        }
      }
    })
    .catch((err) => {
      // console.log("ERROR2", err)
    })
    .finally(() =>{
      //TODO: Set loading
    })
  }
  //end of custom stuff

///
const authData = {
  apiLoginID: process.env.REACT_APP_AUTHORIZE_NET_A_LOGINID,
  clientKey: process.env.REACT_APP_AUTHORIZE_NET_A_CLIENTKEY,
};

const { dispatchData, loading2, error } = useAcceptJs({ environment:process.env.REACT_APP_AUTHORIZE_NET_A_ENV, authData });
const [cardData, setCardData] = useState({
  cardNumber: '',
  expMonth: '',
  expYear: '',
  cardCode: '',
  zipCode: '',
});

const handleSubmit = async (event) => {
  event.preventDefault();

  if(!cardData.zipCode){
    setformError("all fields are requried");
  }
  else{
    try {
      setLoading(true)

      // Dispatch CC data to Authorize.net and receive payment nonce for use on your server
      const opaqueData = await dispatchData({
        cardData: {
          ...cardData,
          month: cardData.expMonth,
          year: cardData.expYear,
        },
      });
      setCardToken({
        token: opaqueData.opaqueData.dataValue,
        card:{
          exp_month: cardData.expMonth,
          exp_year: cardData.expYear,
          last4: cardData.cardNumber.slice(-4),
          bin: cardData.cardNumber.substring(0, 6)
        }
      })

      setTimeout(() => {
        SendIFrameMessage(null, "SendBillingData");
      }, 1000)
    } catch (e) {
      //TODO: Alert
      if(e.messages && e.messages.message && e.messages.message[0])
        setformError(e.messages.message[0].text)
      // console.log(JSON.stringify(e, null, 2));
    }
    finally{
      setCardData({
        cardNumber: '',
        expMonth: '',
        expYear: '',
        cardCode: '',
        zipCode: '',
      })
      setformError("")
      setLoading(false);
    }
  }
};

const validateWholeNumber = (value) => {
  const wholeNumberRegex = /^\d*$/; // Regular expression to match whole numbers
  return wholeNumberRegex.test(value)
};

return (
  <div className ="mwContainer">
    {loading &&
    <Row>
      <Col md = "12">
        <h1>Processing ...</h1>
      </Col>
    </Row>
  } 
    
  {!loading &&
    <form onSubmit={handleSubmit} className="payment-form">
      <div className="card-container">
        <div className="card-input">
          <input
            type="text"
            className="form-control"
            name="cardNumber"
            value={cardData.cardNumber}
            placeholder="•••• •••• •••• ••••" 
            onChange={(event) =>
              setCardData({ ...cardData, cardNumber: event.target.value })
            }
          />
        </div>
        
        <div className="card-input">
          <div className="date-input">
            <input
              type="text"
              className="small-input month-input"
              name="expMonth"
              maxLength = {2}
              value={cardData.expMonth}
              placeholder = "mm"
              onChange={(event) => {
                if(validateWholeNumber(event.target.value))
                  setCardData({ ...cardData, expMonth: event.target.value })
                else return false
              }}
            />
  
          <span class="separator">/</span>

            <input
              type="text"
              className="small-input year-input"
              name="expYear"
              maxLength = {2}
              placeholder = "yy"
              value={cardData.expYear}
              onChange={(event) => {
                if(validateWholeNumber(event.target.value))
                  setCardData({ ...cardData, expYear: event.target.value })
                else return false
              }}
            />
          </div>

            <input
              type="text"
              className="small-input"
              name="cardCode"
              maxLength={3}
              placeholder = "cvv"
              value={cardData.cardCode}
              onChange={(event) => {
                if(validateWholeNumber(event.target.value))
                  setCardData({ ...cardData, cardCode: event.target.value })
                else return false
              }}
            />
            
            <input
              type="text"
              className="small-input"
              name="zipCode"
              placeholder = "zip"
              maxLength = {5}
              value={cardData.zipCode}
              onChange={(event) => {
                if(validateWholeNumber(event.target.value))
                  setCardData({ ...cardData, zipCode: event.target.value })
                else return false
              }}
            />
        </div>

        <div className="card-input">
          <label htmlFor="expMonth" className="small-input">
            Exp. Date
          </label>



          <label htmlFor="cardCode" className="small-input">
            CVV
          </label>

          <label htmlFor="zipCode" className="small-input">
            Zip
          </label>
        </div>

      </div>

      <div className ="error-message">
          {formError && <p>{formError}</p> }
      </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={loading2 || error}
        >
          Pay
        </button>
    </form>
  }
</div>
  );
};


export default AuthorizeNetA;